import { AnimatePresence, motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { usePlayground } from "../../playground-store";
import AddTestCaseButton from "./AddTestCaseButton";
import { TestCase } from "./TestCase";

const TestCases = observer(
  ({
    inputVariableSets,
    containerRef,
    onSetClick,
  }: {
    inputVariableSets: any[];
    containerRef: React.RefObject<HTMLDivElement>;
    onSetClick: (setId: string, scroll: boolean) => void;
  }) => {
    const playground = usePlayground();

    return (
      <div className="pointer-events-auto relative w-full">
        <div
          ref={containerRef}
          className="scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent flex overflow-x-auto pb-2"
        >
          <div className="flex items-center gap-x-2 px-0.5">
            <AnimatePresence mode="popLayout" initial={false}>
              {inputVariableSets.map((set, index) => (
                <motion.div
                  layout
                  key={set.id}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{
                    duration: 0.2,
                    ease: "easeInOut",
                  }}
                >
                  <TestCase
                    set={set}
                    number={index + 1}
                    onDuplicate={(newSetId) => onSetClick(newSetId, true)}
                    onClick={() => onSetClick(set.id, false)}
                  />
                </motion.div>
              ))}
              {playground.canAddInputVariableSet && (
                <AddTestCaseButton onAdd={(setId) => onSetClick(setId, true)} />
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    );
  },
);

export default TestCases;
